import Vue from "vue";
import Component from "vue-class-component";
import HeaderContainer from "./header/HeaderContainer.vue";
import { namespace, Getter, State, Action } from "vuex-class";
import { storeModules } from "../store";
import { AuthVerified } from "../models/generic/auth-transfer";
// import TabWrapper from "../components/tabs";
import NavbarComponent from './header/components/NavbarComponent.vue';
import TabComponent from './tab-views/TabComponent.vue';
import Sidebar from './sidebar';
import { EVENT_BUS, WEBAPP_LAYOUT, CACHE_COMPONENT_NAME } from "../common/constants";
import EventBus from "../utils/event-bus";
import { LocalforageWrapper } from "../utils/localforage-form-data-wrapper";
import {storeTypes} from '../store';

import LookupDataListener from '../components/data-change-listener/lookup-data';
import AppConfigListener from '../components/data-change-listener/config';
import PhoneListener from '../components/phone-listener';

import { OpenAppointmentPropsModel } from "../store/types";
import $ from "jquery";

const OpenAppointmentComponent = () => import('../containers/controls/open-appointment/OpenAppointmentComponent.vue');
const NotificationCenter = () => import("../components/notification-center/NotificationCenterComponent.vue");
const ConflictDataModalComponent = () => import("../components/conflict-data-modal/ConflictDataModalComponent.vue");

const CommonGetter = namespace(storeModules.Common, Getter);
const CommonState = namespace(storeModules.Common, State);
const CommonAction = namespace(storeModules.Common, Action);

@Component({
    template: require("./template01.html"),
    components: {
        "app-header": HeaderContainer,
        'header-navbar': NavbarComponent,
        'tab-views': TabComponent,
        'sidebar-filter': Sidebar,
        'open-appointment-modal': OpenAppointmentComponent,
        LookupDataListener,
        AppConfigListener,
        PhoneListener,
        NotificationCenter,
        'dynamic-drawer': () => import("../components/dynamic-drawer/DrawerComponent.vue"),
        "conflict-data-modal": ConflictDataModalComponent,
        "ai-generate-description-warning-dialog": () => import("../components/ai-generate-description-warning-dialog/AIGenerateDescriptionWarningDialog.vue")
    }
})
class App extends Vue {
    routeKey: any = {
        client: 0,
        property: 0,
        demand: 0,
        task: 0
    }
    dtDefaultSettingName: string;
    @CommonGetter userSession: AuthVerified;
    @CommonGetter isPageRendered: boolean;
    @CommonGetter getLoadingPage: boolean;
    @CommonGetter getStreaming: boolean;
    @CommonAction(storeTypes.Set.SET_STREAMING_PAGE) setStreamingPage: (payload: boolean) => void;

    @CommonState('webappLayoutMode') webappLayoutMode: string;
    @CommonState('openAppointmentModalProps') storeOpenAppointmentProps: OpenAppointmentPropsModel;

    renderContainer: boolean = false;
    isShowWarningDialog: boolean = false;
    get isPageReady() {
        return this.isPageRendered;
    }
    get coLoading(): boolean { return this.getLoadingPage || false }
    get coStreaming(): boolean { return this.getStreaming || false }
    get coIsShowWarningDialog(): boolean { return this.isShowWarningDialog;}
    set coIsShowWarningDialog(value: boolean) { this.isShowWarningDialog = value; } 
    get pointerEvents(): string {
        return this.coStreaming ? 'none' : 'auto';
    }

    get keepComponents() {
        return CACHE_COMPONENT_NAME;
    }

    get getRouterViewKey() {
        return `${this.$route.name}-${this.$route.meta.viewType}-${this.$route.params.id || this.routeKey[this.$route.name]}`;
    }

    get webappLayouts() {
        return WEBAPP_LAYOUT;
    }

    /**
     *
     */
    constructor() {
        super();
        this.dtDefaultSettingName = "App";
    }

    mounted() {
        $("#omnicasa-loading-icon").fadeOut("slow");
        this.calculateHeightTabContainer();
        window.addEventListener('resize', this.calculateHeightTabContainer, false);
        // keep-alive no longer caches a component after calling $destroy on it once
        this.listenEventClearMemory(); // https://github.com/vuejs/vue/issues/9019
        LocalforageWrapper.clear();
        window.addEventListener('load', () => {
            function updateOnlineStatus() {
                var condition = navigator.onLine ? "online" : "offline";
                if (condition == 'online') {
                    console.log('condition: online')
                    location.reload();
                } else {
                    console.log('condition: offline')
                }
            }
            window.addEventListener('online', updateOnlineStatus);
            window.addEventListener('offline', updateOnlineStatus);

        });
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.calculateHeightTabContainer, false);
    }

    listenEventClearMemory() {
        EventBus.$on(EVENT_BUS.PERSON.CLEAR_MEMORY, () => {
            this.routeKey.client += 1;
        });
        EventBus.$on(EVENT_BUS.PROPERTY.CLEAR_MEMORY, () => {
            this.routeKey.property += 1;
        });
        EventBus.$on(EVENT_BUS.DEMAND.CLEAR_MEMORY, () => {
            this.routeKey.demand += 1;
        });
        EventBus.$on(EVENT_BUS.TASK.CLEAR_MEMORY, () => {
            this.routeKey.task += 1;
        });
    }

    calculateHeightTabContainer() {
        if ((this as any).$refs.tabcontainer) {
            const bodyRect = window.document.body.getBoundingClientRect();
            const containerRect = (this as any).$refs.tabcontainer.getBoundingClientRect();
            const height = bodyRect.height - containerRect.y - 10;
            (this as any).$refs.tabcontainer.style.height = `${height}px`;
        }
    }


    handleClickEvent(e) {
        if (this.coStreaming) {
            this.isShowWarningDialog = true;
        } else {
            this.isShowWarningDialog = false;
        }
    }

    continueGenerating(e) {
        this.isShowWarningDialog = false;
        e.stopPropagation();
    }

    stopGenerating() {
        this.setStreamingPage(false);
        this.coIsShowWarningDialog = false;
    }


}

export default App;
